export const getSurveyByKey = (key:string) =>{
	const getSurveys = localStorage.getItem('surveys')
  const getSurveysKeys = getSurveys ? JSON.parse(getSurveys) : ''
  
  if(getSurveysKeys?.length) return findSurveysByKey(getSurveysKeys, key)

	return undefined
}

const findSurveysByKey = (surveys:any, key:string) => surveys.find((survey: any) => survey.key === key)